export default {
  marketscale: {
    headline: 'Owning the Walkthrough Process with Ricardo Regalado of Route',
    url: 'https://marketscale.com/industries/building-management/route-walkthrough-data-driven/'
  },
  adonrigg: {
    headline: 'Importance of the Walk Through - Cleaning Up In Sales with GetRoute',
    url: 'https://www.youtube.com/watch?v=imN50Kw3sFU&feature=youtu.be'
  },
  alphahippie: {
    headline: 'Serial Entrepreneur Life With Ricky Regalado',
    url: 'https://alphahippiepodcast.com/ricky-regalado/'
  },
  contractorinnovation: {
    headline: 'Ricky On Contractor Innovation',
    url: 'https://www.youtube.com/watch?v=ZWl6ABX9MGs'
  },
  press1871: {
    headline: 'Second Cohort of the 1871 + IHCC Hispanic Technology Incubator Begins Program',
    url:
      'https://www.ihccbusiness.net/ihccnews/2017/6/2/second-cohort-of-the-1871-ihcc-hispanic-technology-incubator-begins-program'
  },
  builtin: {
    headline: 'Goodbye clipboards, hello smartwatches: RozaRoute helps cleaning companies go digital',
    url: 'https://www.builtinchicago.org/2017/10/09/rozaroute-cleaning-workflow-management'
  },
  catapult: {
    headline: 'Route wins CATAPULT competition!',
    url: 'http://www.nmsdc.org/nmsdc-capital-one-announce-winner-catapult-competition/'
  },
  tastytrade: {
    headline: 'Bootstrapping in America: Ricardo Regalado of Rozalado Cleaning',
    url:
      'https://www.tastytrade.com/tt/shows/bootstrapping-in-america/episodes/ricardo-regalado-of-rozalado-cleaning-08-15-2017'
  }
  // voyage: {
  //   headline: 'Meet Ricardo Regalado of Rozalado Services and RozaRoute',
  //   url: 'http://voyagechicago.com/interview/meet-ricardo-regalado-rozalado-services-rozaroute-located-albany-park-area-remote-office-fulton-market-area-well/'
  // }
}
